// extracted by mini-css-extract-plugin
export default {"container":"kZ-z","list":"lZ-z"};